export default function PageHeader({ overline, title, children }) {
  return (
    <div className="h-16 border-b border-white/10 flex items-center justify-between px-6 lg:px-8 bg-background">
      <div>
        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-muted-foreground leading-none mb-1">
          {overline}
        </p>
        <h1 className="font-heading text-xl lg:text-2xl font-bold tracking-tight leading-none">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-3">{children}</div>
    </div>
  );
}
